import { useState, useEffect } from "react";
import { useNavigate, useParams  } from "react-router-dom";
import { toast } from "react-toastify";
import moment from 'moment';
import Header from '../shared/components/Header'
import { useDispatch, useSelector } from "react-redux";
import { addCliente, fetchClientes, updateCliente } from "../../../../redux/clientes";
import { ENTIDADES_API } from "../shared/services/clientes";
import InfoModal from "../shared/components/InfoModal";
import ExportForm from "../shared/components/ExportForm";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab } from "@mui/material";
import EntityTable from "./components/EntityTable";
import { DIRECCIONES_API } from "../shared/services/direcciones";
import ClienteModal from "../shared/components/ClienteModal";
import { isBoolean, setErrorMessage } from "../shared/helpers/functionalities";
import ClienteCreditoFacturas from "./components/ClienteCreditoFacturas";
import FusionForm from "./components/FusionForm";

export default function Clientes() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { page } = useParams();
  const currPage = parseInt(page); 
  const currTab = localStorage.getItem('clientes-tab');
  const [currentPage, setPage] = useState(currPage);
  const [tab, setTab] = useState(currTab ? currTab : 'cliente');
  const [currentCliente, setCurrentCliente] = useState(null);
  const [isExportClientes, setIsExportClientes] = useState(false);
  const [isExportClientesMargen, setIsExportClientesMargen] = useState(false);
  const [isExportFeedback, setIsExportFeedback] = useState(false);
  const [isExportExtraccion, setIsExportExtraccion] = useState(false);
  const [isOpenForm, setIsOpenForm] = useState(false);
  const [isOpenFacturasCredito, setIsOpenFacturasCredito] = useState(false);
  const [isFusion, setIsFusion] = useState(false);
  const searcher = useSelector((state) => state.search);
  const clientes = useSelector(state => state.clientes);
  
  useEffect(() => {
    dispatch(fetchClientes(currentPage, getQuery(tab)));
  }, [searcher]);

  const getQuery = (section = null) => {
    let query;
    if(searcher) {
      const isEmpty = Object.values(searcher).every(x => x === null || x === '');
      query = !isEmpty ? '&seccion=' + section + '&search=' + (searcher?.search ? searcher?.search : '')
        + (isBoolean(searcher?.credito) ? '&credito=' + searcher?.credito : '')
        + (isBoolean(searcher?.sepa) ? '&sepa=' + searcher?.sepa : '')
      : '&seccion=' + (section ? section : tab);
    } else query = '&seccion=' + (section ? section : tab);

    return query;
  }

  const handleSearch = (searchData) => {
    navigate(`/clientes/${1}`);
    dispatch({type: "search/set", payload: searchData});     
  }

  const handleChangePage = (newPage) => {
    setPage(newPage);
    navigate(`/clientes/${newPage}`);
    dispatch(fetchClientes(newPage, getQuery(tab)));
  }

  const handleChangeTab = (e, newTab) => { 
    setTab(newTab);
    setPage(1);
    navigate(`/clientes/${1}`);
    localStorage.setItem('clientes-tab', newTab); 
    dispatch(fetchClientes(1, getQuery(newTab)));
  }

  const handleExportCompras = async(data) => {
    dispatch({type: 'loading/set', payload: true});
    const exportResult = await ENTIDADES_API.exportCompras(data);

    if(exportResult) {
      const today = moment().format('YYYY-MM-DD');
      toast.success('Listado de compras descargado correctamente!')
      
      const url = window.URL.createObjectURL(new Blob([exportResult]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'compras_B2B_' + today + '.xlsx');
      document.body.appendChild(link);
      link.click();
    } else {
      toast.error('Ups! Algo ha ido mal...')
    }
    
    dispatch({type: 'loading/set', payload: false});
    setIsExportClientes(false);
  }

  const handleExportFeedback = async(data) => {
    dispatch({type: 'loading/set', payload: true});
    const exportResult = await ENTIDADES_API.exportFeedback(data);

    if(exportResult) {
      toast.success('Listado de compras descargado correctamente!')
    
      const url = window.URL.createObjectURL(new Blob([exportResult]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'feedback_clientes.xlsx');
      document.body.appendChild(link);
      link.click();
    } else {
      toast.error('Ups! Algo ha ido mal...')
    }
    
    dispatch({type: 'loading/set', payload: false});
    setIsExportFeedback(false);
  }

  const handleExportComprasMargen = async(data) => {
    dispatch({type: 'loading/set', payload: true});
    const exportResult = await ENTIDADES_API.exportComprasMargen(data);

    if(exportResult) {
      toast.success('Listado de compras descargado correctamente!')
    
      const url = window.URL.createObjectURL(new Blob([exportResult]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'compras_margen.xlsx');
      document.body.appendChild(link);
      link.click();
    } else {
      toast.error('Ups! Algo ha ido mal...')
    }
    
    dispatch({type: 'loading/set', payload: false});
    setIsExportClientesMargen(false);
  }

  const handleExportExtraccion = async(data) => {
    dispatch({type: 'loading/set', payload: true});
    const cliente = data.cliente;
    data.entity_id = cliente.id;
    delete data.cliente;
    const exportResult = await ENTIDADES_API.exportFacturas(data);

    if(exportResult) {
      const start = moment(data.startDate).format('DD-MM-YYYY');
      const end = moment(data.endDate).format('DD-MM-YYYY');
      toast.success('Extracción descargada correctamente!')
    
      const url = window.URL.createObjectURL(new Blob([exportResult]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'desglose_albaranes_' + cliente.nombre + '_' + start + '_' + end + '.xlsx');
      document.body.appendChild(link);
      link.click();
    } else {
      toast.error('Ups! Algo ha ido mal...')
    }

    dispatch({type: 'loading/set', payload: false});
    setIsExportExtraccion(false);
  }

  const handleExport = (item) => { 
    if(item === 'ventas') setIsExportClientes(true);
    else if(item === 'margen') setIsExportClientesMargen(true);
    else if(item === 'extraccion') setIsExportExtraccion(true);
    else setIsExportFeedback(true);
  }
  const handleCloseExportClientes = () => setIsExportClientes(false);
  const handleCloseExportClientesMargen = () => setIsExportClientesMargen(false);
  const handleCloseExportFeedback = () => setIsExportFeedback(false);
  const handleCloseExtraccion = () => setIsExportExtraccion(false);

  const handleOpenClienteForm = async (cliente) => {
    let clienteData = cliente;
    if(cliente) {
      try {
        dispatch({ type: 'loading/set', payload: true });
        const res = await ENTIDADES_API.getDetail(cliente.id);
        if(res.success) {
          clienteData = {...cliente, ...res.data}
        } else {
          toast.error('No se ha podido obtener toda la información del cliente')
        }
      } catch (e) {
        toast.error(setErrorMessage(e))
      } finally {
        dispatch({ type: 'loading/set', payload: false });
      }
    }
    setIsOpenForm(true); 
    setCurrentCliente(clienteData);
  }
  const handleCloseClienteForm = () => { setIsOpenForm(false); }

  const handleSubmitCliente = async(cliente) => {
    const isEditing = cliente.id !== "";
    let response;

    try {
      dispatch({ type: 'loading/set', payload: true });
      if(isEditing) {
        response = await ENTIDADES_API.update(cliente)
      } else {
        delete cliente.id;
        response = await ENTIDADES_API.new(cliente)
      }
      if(response && response.success) {
        if(isEditing) {
          dispatch(updateCliente(response.data)) 
        } else if(tab === 'contacto') {
          dispatch(addCliente(response.data))
        }
        toast.success(response.message);
        setIsOpenForm(false);
        setCurrentCliente(null);
      } else {
        toast.error('ERROR! Cliente ya registrado.');
      }
    } catch (e) {
      toast.error(setErrorMessage(e))
    } finally {
      dispatch({type: 'loading/set', payload: false});
    }
  }

  const handleSubmitDireccion = async(isEdit, direccion) => {
    let response;
    try {
      dispatch({type: 'loading/set', payload: true});
  
      if(isEdit) {
        response = await DIRECCIONES_API.update(direccion);
      } else {
        response = await DIRECCIONES_API.new(direccion);
      }
      
      if(response && response.success) {
        const newAddress = response.data;
        const direcciones = isEdit
          ? currentCliente.direcciones.map(address => address.id === newAddress.id ? newAddress : address)
          : [...currentCliente.direcciones, newAddress]
        setCurrentCliente({
          ...currentCliente,
          direcciones
        })
        toast.success(response.message);
      }
    } catch (e) {
      toast.error(setErrorMessage(e))
    } finally {
      dispatch({type: 'loading/set', payload: false});
    }
  }

  const handleOpenFacturasCredito = async (cliente) => {
    let clienteData = cliente;
    try {
      dispatch({ type: 'loading/set', payload: true });
      const res = await ENTIDADES_API.getInvoices(cliente.id);
      if(res?.success) {
        clienteData = {...cliente, ...res.data}
      }
    } catch (e) {
      toast.error(setErrorMessage(e))
    } finally {
      setCurrentCliente(clienteData); 
      dispatch({ type: 'loading/set', payload: false });
      setIsOpenFacturasCredito(true); 
    }
  }
  const handleCloseFacturasCredito = () => { setIsOpenFacturasCredito(false); setCurrentCliente(null); }
  const handleFacturaCreditoCobrada = (factura) => { 
    dispatch(fetchClientes(currentPage, getQuery(tab)));
    const clienteAux = {...currentCliente};
    const facturas = clienteAux.facturas_credito?.map(fact => {
      if(fact.id === factura.id) {
        return {
          ...fact,
          cobrada: factura.cobrada,
          fecha_cobrada: factura.fecha_cobrada
        }
      } else return fact;
    });
    
    clienteAux.facturas_credito = facturas;
    setCurrentCliente(clienteAux);
  }

  const handleOpenFusion = async (cliente) => {
    let restOfAddress = {};
    try {
      dispatch({type: 'loading/set', payload: true});
      const res = await ENTIDADES_API.getAddressInfo(cliente.id)
      if(res?.success) {
        restOfAddress = res.data;
      }
    } catch (e) {
      toast.error(setErrorMessage(e))
    } finally {
      setCurrentCliente({...cliente, ...restOfAddress})
      dispatch({type: 'loading/set', payload: false});
      setIsFusion(true); 
    }
  }

  const handleCloseFusion = () => setIsFusion(false);
  const handleFusion = async(data) => {
    try {
      dispatch({type: 'loading/set', payload: true});
      const response = await ENTIDADES_API.join(data)
      
      if(response && response.success) { 
        dispatch({type: 'loading/set', payload: false});
        toast.success(response.message);
        const isOldClienteVisible = clientes.clientes.find(cliente => cliente.id === data.from);
        isOldClienteVisible 
          ? dispatch(fetchClientes(currentPage, getQuery(tab)))
          : dispatch(updateCliente(response.data));
        setIsFusion(false);
      }
    } catch (e) {
      toast.error(setErrorMessage(e))
    } finally {
      dispatch({type: 'loading/set', payload: false});
    }
  }

  return (
    <div className="content pt-3">
      <Header 
        onNew={() => handleOpenClienteForm(null)}
        viewSearch={true}
        onSearch={handleSearch}
        onExport={handleExport}
      ></Header>

      <div className="w-100 mt-2">
        <TabContext value={tab}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChangeTab} aria-label="Tipos de clientes">
            <Tab label="Cadenas" value="cadena" />
            <Tab label="Talleres de cadena" value="talleres-cadena" />
            <Tab label="Clientes" value="cliente" />
            <Tab label="Leads" value="lead" />
            <Tab label="Contactos" value="contacto" />
          </TabList>
          </Box>
          <TabPanel value="cadena">
              <EntityTable 
                id={'cadena'}
                currPage={currentPage}
                onEdit={handleOpenClienteForm}
                onPageChange={handleChangePage}
                onOpenFacturasCredito={handleOpenFacturasCredito}
                onFusion={handleOpenFusion}
              />
          </TabPanel>
          <TabPanel value="talleres-cadena">
              <EntityTable 
                id={'talleres-cadena'}
                currPage={currentPage}
                onEdit={handleOpenClienteForm}
                onPageChange={handleChangePage}
                onOpenFacturasCredito={handleOpenFacturasCredito}
                onFusion={handleOpenFusion}
              />
          </TabPanel>
          <TabPanel value="cliente">
              <EntityTable 
                id={'cliente'}
                currPage={currentPage}
                onEdit={handleOpenClienteForm}
                onPageChange={handleChangePage}
                onOpenFacturasCredito={handleOpenFacturasCredito}
                onFusion={handleOpenFusion}
              />
          </TabPanel>
          <TabPanel value="lead">
              <EntityTable 
                id={'lead'}
                currPage={currentPage}
                onEdit={handleOpenClienteForm}
                onPageChange={handleChangePage}
                onFusion={handleOpenFusion}
              />
          </TabPanel>
          <TabPanel value="contacto">
              <EntityTable 
                id={'contacto'}
                currPage={currentPage}
                onEdit={handleOpenClienteForm}
                onPageChange={handleChangePage}
                onFusion={handleOpenFusion}
              />
          </TabPanel>
        </TabContext>
      </div>

      { (isOpenForm) &&
        <ClienteModal
          fromPresupuesto={false} 
          open={isOpenForm}
          cliente={currentCliente}
          telefono={null}
          selectedDireccionId={null}
          isEdit={currentCliente ? true : false}
          onSubmitCliente={handleSubmitCliente}
          onSubmitDireccion={handleSubmitDireccion}
          onClose={handleCloseClienteForm}
        />
      }
      
      { (isExportClientes) && 
        <InfoModal
          state={isExportClientes}
          title="Exportar número de ventas a Excel"
          content={
            <ExportForm 
              dateFilter={true}
              tipoClienteFilter={true}
              tipoFacturasFilter={false}
              responsableFilter={false}
              onSubmitExport={handleExportCompras}
            />
          }
          width={'lg'}
          onClose={handleCloseExportClientes}
        ></InfoModal>
      }

      { (isExportExtraccion) && 
        <InfoModal
          state={isExportExtraccion}
          title="Exportar extracción de desglose de facturas a crédito"
          content={
            <ExportForm 
              dateFilter={true}
              clienteFilter={true}
              tipoClienteFilter={false}
              tipoFacturasFilter={false}
              responsableFilter={false}
              onSubmitExport={handleExportExtraccion}
            />
          }
          onClose={handleCloseExtraccion}
        ></InfoModal>
      }

      { (isExportClientesMargen) && 
        <InfoModal
          state={isExportClientesMargen}
          title="Exportar ventas con margen a Excel"
          content={
            <ExportForm 
              dateFilter={true}
              tipoClienteFilter={true}
              tipoFacturasFilter={false}
              responsableFilter={false}
              onSubmitExport={handleExportComprasMargen}
            />
            }
          onClose={handleCloseExportClientesMargen}
        ></InfoModal>
      }

      { (isExportFeedback) && 
        <InfoModal
          state={isExportFeedback}
          title="Exportar feedback de clientes a Excel"
          content={
            <ExportForm 
              dateFilter={true}
              tipoClienteFilter={false}
              tipoFacturasFilter={false}
              responsableFilter={false}
              onSubmitExport={handleExportFeedback}
            />
            }
          onClose={handleCloseExportFeedback}
        ></InfoModal>
      }

      { (isOpenFacturasCredito) && 
        <InfoModal
          state={isOpenFacturasCredito}
          width={'lg'}
          title={"Administración de facturas a crédito " + currentCliente?.nombre}
          content={
            <ClienteCreditoFacturas
              cliente={currentCliente}
              onMarkAsPaid={handleFacturaCreditoCobrada}
            />
            }
          onClose={handleCloseFacturasCredito}
        ></InfoModal>
      }

      { isFusion && 
        <InfoModal
          width={'lg'}
          state={isFusion}
          title=""
          content={
            <FusionForm 
              cliente={currentCliente}
              onSubmitFusion={handleFusion}
              />
          }
          onClose={handleCloseFusion}
        ></InfoModal>
      }
    </div>
  )
}